import { useContext } from 'react'

import KanbanFiltersContext from 'contexts/KanbanFiltersContext'

const useKanbanFilters = () => {
  const context = useContext(KanbanFiltersContext)

  if (context === undefined) {
    throw new Error(
      'useKanbanFilters must be used within a KanbanFiltersProvider',
    )
  }

  return context
}

export default useKanbanFilters
